import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { LocationService } from '../proxy/planning/controllers/location.service';
import { FirebreakTypeService } from '../proxy/planning/controllers/firebreak-type.service';
import { FirebreakBlockService } from '../proxy/planning/controllers/firebreak-block.service';
import { PropertyService } from '../proxy/planning/controllers/property.service';

FieldBuilder.setNamespace('Planning');

export const FIREBREAK_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .checkbox('isActive', 'Entity.Firebreak.IsActive')
    .build(),
  FieldBuilder
    .number('hectares', 'Entity.Firebreak.Hectares')
    .required()
    .decimal(2,10)
    .build(),
  FieldBuilder
    .foreignKey('firebreakTypeId', 'Entity.FirebreakType', FirebreakTypeService)
    .required()
    .displayFromNested('firebreakType.name')
    .sortBy('firebreakType.name')
    .build(),
  FieldBuilder
    .number('gisFirebreakId', 'Entity.Firebreak.GISFirebreakId')
    .required()
    .build(),
  FieldBuilder
    .foreignKey('firebreakBlockId', 'Entity.FirebreakBlock', FirebreakBlockService)
    .required()
    .displayFromNested('firebreakBlock.gisLandBlockId')
    .build(),
  FieldBuilder
    .foreignKey('propertyId', 'Entity.Property', PropertyService)
    .required()
    .displayFromNested('property.name')
    .sortBy('property.name')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const FIREBREAK_CONFIG = {
  entityName: 'Firebreak',
  localizationKey: 'Planning::Entity.Firebreak',
  permission: 'PlanningLocation.Firebreaks',
  fields: FIREBREAK_FIELDS,

  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
